import { apiClient } from "../../shared/api/httpClient.js";

export async function listPosts({
  cursor,
  pageSize = 20,
  postType,
  search,
} = {}) {
  const response = await apiClient.get("/posts/", {
    params: {
      page_size: pageSize,
      ...(cursor ? { cursor } : {}),
      ...(postType ? { post_type: postType } : {}),
      ...(search ? { search } : {}),
    },
  });
  return response.data;
}

export async function getPost(postId) {
  const response = await apiClient.get(`/posts/${postId}/`);
  return response.data;
}

export async function deletePost(postId) {
  const response = await apiClient.delete(`/posts/${postId}/`);
  return response.data;
}

export async function hidePost(postId, hidden = true) {
  const response = await apiClient.patch(`/posts/${postId}/`, { status: hidden ? "hidden" : "published" });
  return response.data;
}

export async function createPost(payload) {
  const response = await apiClient.post("/posts/", payload);
  return response.data;
}

export async function createPostDraft(payload) {
  const response = await apiClient.post("/drafts/", payload);
  return response.data;
}

export async function listPostDrafts({ page = 1, pageSize = 100 } = {}) {
  const response = await apiClient.get("/drafts/", {
    params: { page, page_size: pageSize },
  });
  return response.data;
}

export async function getPostDraft(draftId) {
  const response = await apiClient.get(`/drafts/${draftId}/`);
  return response.data;
}

export async function updatePostDraft(draftId, payload) {
  const response = await apiClient.patch(`/drafts/${draftId}/`, payload);
  return response.data;
}

export async function publishPostDraft(draftId) {
  const response = await apiClient.post(`/drafts/${draftId}/publish/`);
  return response.data;
}

export async function uploadPostMedia(file, onProgress) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("media_type", "image");

  const response = await apiClient.post("/posts/media/upload/", formData, {
    timeout: 60_000,
    onUploadProgress: (event) => {
      if (!event.total) return;
      onProgress?.(Math.round((event.loaded / event.total) * 100));
    },
  });
  return response.data;
}

export async function setPostLike(postId, liked) {
  const response = await apiClient.request({
    method: liked ? "post" : "delete",
    url: `/posts/${postId}/like/`,
  });
  return response.data;
}

export async function setPostCollection(postId, collected) {
  const response = await apiClient.request({
    method: collected ? "post" : "delete",
    url: `/posts/${postId}/collect/`,
  });
  return response.data;
}

export async function createPostComment(postId, content, { parent, replyToUser } = {}) {
  const response = await apiClient.post(`/posts/${postId}/comments/`, {
    content,
    ...(parent ? { parent } : {}),
    ...(replyToUser ? { reply_to_user: replyToUser } : {}),
  });
  return response.data;
}

export async function listPostComments(postId, cursor) {
  const response = await apiClient.get(`/posts/${postId}/comments/`, {
    params: cursor ? { cursor } : undefined,
  });
  return response.data;
}

export function getCursorFromPageUrl(url) {
  if (!url) return undefined;
  try {
    return new URL(url).searchParams.get("cursor") || undefined;
  } catch {
    return undefined;
  }
}
